/**
 * Bridge Data Import → Control Centre after ingest jobs finish.
 *
 * Import writes notes/orders into the truth layer but does not update
 * Control Centre in-memory state. Dispatch this when a backfill/incremental
 * job completes so FleetDataHub can re-read (settleFetch) without re-ingesting.
 */

export const CONTROL_CENTRE_INGEST_REFRESH_KEY = 'zecure_control_centre_ingest_refresh_v1';
export const CONTROL_CENTRE_INGEST_REFRESH_EVENT = 'zecure:control-centre-ingest-refresh';

export type ControlCentreIngestRefreshDetail = {
  reason?: 'backfill' | 'incremental' | 'ingest';
  jobIds?: string[];
};

/** Notify Control Centre that truth-layer ingest finished successfully. */
export function requestControlCentreIngestRefresh(
  detail: ControlCentreIngestRefreshDetail = {},
): void {
  try {
    sessionStorage.setItem(
      CONTROL_CENTRE_INGEST_REFRESH_KEY,
      JSON.stringify({ at: Date.now(), ...detail }),
    );
    window.dispatchEvent(
      new CustomEvent(CONTROL_CENTRE_INGEST_REFRESH_EVENT, { detail }),
    );
  } catch {
    // ignore quota / private mode
  }
}

/** Consume a pending refresh request (one-shot). Returns true if one was pending. */
export function consumeControlCentreIngestRefresh(): boolean {
  try {
    const raw = sessionStorage.getItem(CONTROL_CENTRE_INGEST_REFRESH_KEY);
    if (!raw) return false;
    sessionStorage.removeItem(CONTROL_CENTRE_INGEST_REFRESH_KEY);
    return true;
  } catch {
    return false;
  }
}
